/* ========================================================================
 * Bootstrap: modal.js & transition.js v3.3.4
 * http://getbootstrap.com/javascript/#modals
 * http://getbootstrap.com/javascript/#transitions 
 * ========================================================================
 * Mods by SAU/CAL between 2014-2018
 * ======================================================================== 
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.ignite-modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.ignite-modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.ig.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.4'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.ig.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('ignite-modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.ig.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.ig.modal', function () {
      that.$element.one('mouseup.dismiss.ig.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('ignite-fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element
        .addClass('in')
        .attr('aria-hidden', false)

      that.enforceFocus()

      var e = $.Event('shown.ig.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('igTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .igEmulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.ig.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.ig.modal')

    this.$element
      .removeClass('in')
      .attr('aria-hidden', true)
      .off('click.dismiss.ig.modal')
      .off('mouseup.dismiss.ig.modal')

    this.$dialog.off('mousedown.dismiss.ig.modal')

    $.support.transition && this.$element.hasClass('ignite-fade') ?
      this.$element
        .one('igTransitionEnd', $.proxy(this.hideModal, this))
        .igEmulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.ig.modal') // guard against infinite focus loop
      .on('focusin.ig.modal', $.proxy(function (e) {
        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.ig.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.ig.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.ig.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.ig.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('ignite-modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.ig.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('ignite-fade') ? 'ignite-fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $('<div class="ignite-modal-backdrop ' + animate + '" />')
        .appendTo(this.$body)

      this.$element.on('click.dismiss.ig.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('igTransitionEnd', callback)
          .igEmulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('ignite-fade') ?
        this.$backdrop
          .one('igTransitionEnd', callbackRemove)
          .igEmulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'ignite-modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('ig.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('ig.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.igniteModal

  $.fn.igniteModal             = Plugin
  $.fn.igniteModal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.igniteModal.noConflict = function () {
    $.fn.igniteModal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.ig.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('ig.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.ig.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.ig.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.igEmulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('igTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.igTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

  // igniteModal Initialization
  // ============================================================

  var newElem = function(tag, _class, _opts){
    if(typeof _class == "object"){
      _opts = _class;
      _class = undefined;
    }
    var def = {};
    if(typeof _class != "undefined") {
      def = {
        "class": _class
      };
    }
    var opts = $.extend(true, {}, def);
    opts = $.extend(true, opts, _opts);
    return $("<"+tag+"/>", opts);
  }

  var newDiv = function(_class, divOpts){
    return newElem("div", _class, divOpts);
  }

  $.ignitePopUp = function(options){
    options = $.extend({
      contents: "",
      title: false,
      buttons: {},
      closeUponDone: false,
      id: "ignitePopUp",
      submitFormsWithPrimary: false,
      icon: false,
      width: false
    }, options);

    var thisDef = new $.Deferred();

    var modalProps = {
      "id": options.id,
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    };
    if(options.title !== false){
      modalProps = $.extend(true,modalProps, {
        "aria-labelledby": options.id+"Label"
      });
    }

    var widgetBigArea = newDiv("ignite-modal ignite-fade", modalProps).appendTo("body");
    var widgetPosition = newDiv("ignite-modal-dialog").appendTo(widgetBigArea);
    if( options.width ) {
      widgetPosition.css( "width", options.width );
    }
    var widgetContainer = newDiv("ignite-modal-content").appendTo(widgetPosition);


    var closeWidgetFunc = function(){
      widgetBigArea.igniteModal("hide").one("hidden.ig.modal", function(){
        widgetBigArea.remove();
      })
    }

    var header = newDiv("ignite-modal-header")
      .append($('<button type="button" class="close" aria-hidden="true">&times;</button>').on("click", closeWidgetFunc))
      .appendTo(widgetContainer);

    if(options.title !== false || options.icon !== false){
      header.addClass("with-header-content");
      var headerInner = newDiv("ignite-modal-header-inner clearfix")
        .prependTo(header);

      if(options.icon !== false) {
        headerInner.append('<span class="ignite-modal-icon" id="'+options.id+'Icon">'+options.icon+'</span>')
      }
      if(options.title !== false) {
        headerInner.append('<span class="ignite-modal-title" id="'+options.id+'Label">'+options.title+'</span>')
      }
    }

    var contents = newDiv("ignite-modal-body").appendTo(widgetContainer);

    contents.append(options.contents);

    if(Object.keys(options.buttons).length > 0){
      var buttons = newDiv("ignite-modal-footer").appendTo(widgetContainer);
      $.each(options.buttons, function(id, buttonInfo){
        buttonInfo = $.extend(true, {
          text: "",
          css: {},
          callback: function(){},
          "class": "btn-default"
        }, buttonInfo);
        
        var button = $("<button type='button' class='btn "+buttonInfo.class+"'>"+buttonInfo.text+"</button>").css(buttonInfo.css).on("click", function(){
          if(options.submitFormsWithPrimary && $(this).is(".btn-primary") && contents.find("form").length > 0){
            $(this).addClass('disabled');
            contents.find("form").trigger("submit");
            $(this).removeClass('disabled');
            if(!contents.find("form").data("validated"))
              return;

          }
          buttonInfo.callback.call(thisDef, button);
        }).appendTo(buttons);
      });
      if(options.submitFormsWithPrimary){
        var form = contents.find("form");
        var btns = form.find("button, input[type='submit'], input[type='image']");
        if(btns.length == 0){
          form.append(newElem("button").hide())
        }
        form.on("submit", function(e){
          if(buttons.find(".btn-primary").length == 1){
            e.preventDefault();
            if(!buttons.find(".btn-primary").hasClass('disabled'))
              buttons.find(".btn-primary").click();
          }
        });
      }
    }

    thisDef.fail(closeWidgetFunc)

    widgetBigArea.igniteModal()
    widgetBigArea.on("hide.ig.modal", function(){
      if(thisDef.state("pending")){
        thisDef.reject();
      }
    })
    widgetBigArea.on("shown.ig.modal", function(){
      $("body").addClass('ignite-modal-open');
    })

    if(options.closeUponDone){
      thisDef.done(closeWidgetFunc);
    }

    return {
      promise: function(){
        return thisDef.promise();
      },
      on: function(event, delegate, callback){
        if(event == "shown")
          event = "shown.ig.modal";

        widgetBigArea.on(event, delegate, callback);
      },
      trigger: $.proxy( widgetBigArea.trigger, widgetBigArea )
    };
  }

  $.fn.ignitePopUp = function(options) {
    options = $.extend({
      contents: $(this),
    }, options);

    return $.ignitePopUp(options);
  }

}(jQuery);

//# sourceMappingURL=../../source/_maps/js/frontend/ignite-modal.js.map
